import { render, staticRenderFns } from "./pwa_article_conditions.vue?vue&type=template&id=8b0175ea&scoped=true&"
import script from "./pwa_article_conditions.vue?vue&type=script&lang=js&"
export * from "./pwa_article_conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0175ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b0175ea')) {
      api.createRecord('8b0175ea', component.options)
    } else {
      api.reload('8b0175ea', component.options)
    }
    module.hot.accept("./pwa_article_conditions.vue?vue&type=template&id=8b0175ea&scoped=true&", function () {
      api.rerender('8b0175ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/texts/pwa_article_conditions.vue"
export default component.exports